export const i18n = {
    en: {
        'Bad file type': 'Bad file type',
        'Deselect all': 'Deselect all',
        'project.Done': 'Done',
        'Drag and drop files or': 'Drag and drop files or',
        'other event(s)': 'other event(s)',
        'File(s)': 'File(s)',
        'project.In progress': 'In progress',
        Less: 'Less',
        More: 'More',
        None: 'None',
        Search: 'Search',
        'Search...': 'Search...',
        'Search or create a new...': 'Search or create a new...',
        'Select...': 'Select...',
        'Select all': 'Select all',
        'Select files': 'Select files',
        'Select or create a new...': 'Select or create a new...',
        'project.To do': 'To do',
        'project.To validate': 'To validate',
        You: 'You'
    },
    de: {
        'Bad file type': 'Bad file type',
        'Deselect all': 'Deselect all',
        'other event(s)': 'other event(s)',
        'project.Done': 'Done',
        'Drag and drop files or': 'Drag and drop files or',
        'File(s)': 'File(s)',
        'project.In progress': 'In progress',
        Less: 'Less',
        More: 'More',
        None: 'None',
        Search: 'Search',
        'Search...': 'Search...',
        'Search or create a new...': 'Search or create a new...',
        'Select...': 'Select...',
        'Select all': 'Select all',
        'Select files': 'Select files',
        'Select or create a new...': 'Select or create a new...',
        'project.To do': 'To do',
        'project.To validate': 'To validate',
        You: 'You'
    },
    fr: {
        'Bad file type': 'Mauvais type de fichier',
        'Deselect all': 'Déselectionner tout',
        'other event(s)': 'autre(s) événement(s)',
        'project.Done': 'Fait',
        'Drag and drop files or': 'Glisser-déposer des fichiers ou',
        'File(s)': 'Fichier(s)',
        'project.In progress': 'En cours',
        Less: 'Moins',
        More: 'Plus',
        None: 'Aucun',
        Search: 'Recherche',
        'Search...': 'Rechercher...',
        'Search or create a new...': 'Rechercher ou créer un nouveau...',
        'Select...': 'Sélectionner...',
        'Select all': 'Sélectionner tout',
        'Select files': 'Sélectionner des fichiers',
        'Select or create a new...': 'Sélectionner ou créer un nouveau...',
        'project.To do': 'À faire',
        'project.To validate': 'À valider',
        You: 'Vous'
    }
};
